import { Box } from "@mui/material";
import { FormikProps } from "formik";
import { ReactNode, Suspense, useEffect } from "react";
import { useLoadingContext } from "../../../../../../../../../context/LoadingProvider";
import { EncounterSumaryFormTypeEnum } from "../../../../../../../../../services";
import { Form2Payload } from "../../../../../../scheduling/appointment/encounter/encounter-constant";
import BirpNote from "../note-forms/BirpNote";
import CollaborativeCareModelForm from "../note-forms/CollaborativeCareModelForm";
import DapNote from "../note-forms/DapNote";
import InitialPsychotherapyEvolution from "../note-forms/InitialPsychotherapyEvolution";
import PreOperativeNote from "../note-forms/PreOperativeNote";
import PrimaryCareSoapNote from "../note-forms/PrimaryCareSoapNote";
import PsychiatricNote from "../note-forms/PsychiatricNote";
import PsychiatricProgressExam from "../note-forms/PsychiatricProgressExam";
import PsychodynamicTherapy from "../note-forms/PsychodynamicTherapy";
import PsychoeducationTherapyForm from "../note-forms/PsychoeducationTherapyForm";
import ProgressNote from "../note-forms/ProgressNote";
import PsychodTherapy from "../note-forms/Psychotherapy";
import SimpleSoapNote from "../note-forms/SimpleSoapNote";
import TreatMentPlanNote from "../note-forms/TreatMentPlanNote";

interface IntakeFormDataProps {
  curForm?: VisitNote;
  formik: FormikProps<Form2Payload>;
  onModalityChange?: (modality: string) => void;
}

export type VisitNote = EncounterSumaryFormTypeEnum;

const ActiveForm = ({
  formik,
  curForm,
  onModalityChange,
}: IntakeFormDataProps) => {
  const FormMapping: Record<VisitNote, ReactNode> = {
    SIMPLE_SOAP_NOTE: <SimpleSoapNote formik={formik} />,
    PSYCHIATRIC_NOTE: <PsychiatricNote formik={formik} />,
    PRIMARY_CARE_SOAP_NOTE: <PrimaryCareSoapNote formik={formik} />,
    TREATMENT_PLAN: <TreatMentPlanNote formik={formik} />,
    PREOPERATIVE_NOTE: <PreOperativeNote formik={formik} />,
    FREE_SOAP_NOTE: null,
    PSYCHIATRIC_PROGRESS: <PsychiatricProgressExam formik={formik} />,
    INITIAL_PSYCHOTHERAPY: <InitialPsychotherapyEvolution formik={formik} />,
    PSYCHIATRIC_INITIAL_VISIT_NOTE: null,
    PSYCHODYNAMIC_THERAPY_NOTE: <PsychodynamicTherapy formik={formik} />,
    PSYCHOTHERAPY_NOTE: (
      <PsychodTherapy formik={formik} onModalityChange={onModalityChange} />
    ),
    // INDIVIDUAL_THERAPY_NOTE: <IndividualTherapyForm formik={formik} />,
    COLLABORATIVE_CARE_MODEL: <CollaborativeCareModelForm formik={formik} />,
    PSYCHOEDUCATION_THERAPY: (
      <PsychoeducationTherapyForm formik={formik} showCodes />
    ),
    DAP_NOTE: <DapNote formik={formik} />,
    BIRP_NOTE: <BirpNote formik={formik} />,
    PROGRESS_NOTE: <ProgressNote formik={formik} />,
  };

  return (
    <Box>
      <Suspense fallback={<FallBackComp />}>
        {curForm && FormMapping[curForm]}
      </Suspense>
    </Box>
  );
};

const FallBackComp = () => {
  const { setIsLoading } = useLoadingContext();

  useEffect(() => {
    setIsLoading(true);

    return () => setIsLoading(false);
  }, []);

  return null;
};

export default ActiveForm;
